import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { GenerateCodeRequest } from '../../models/generate-code-request';
import { LoaderService } from '../../../../shared/services/loader.service';
import { DialogNavigationService } from '../../../../shared/services/dialog-navigation.service';

@Component({
  selector: 'app-recover-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './recover-dialog.component.html',
  styleUrl: './recover-dialog.component.scss',
})
export class RecoverDialogComponent implements OnInit {
  form: FormGroup;
  correoIncorrecto: Boolean = false;
  uuidClient: number = 0;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RecoverDialogComponent>,
    private router: Router,
    private authService: AuthService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private dialogNavigation: DialogNavigationService
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    // Obtener uuidc del localStorage o de los query params
    const storedUuidClient = localStorage.getItem('uuidClient');
    if (storedUuidClient) {
      this.uuidClient = parseInt(storedUuidClient);
    }
  }

  submit() {
    if (this.form.valid) {
      const email = this.form.value.email;

      const payload: GenerateCodeRequest = {
        identifier: {
          tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
          app: 'PortalAsistencia',
        },
        petition: {
          email: email,
        },
      };

      this.loader.show();

      this.authService.generateCode(payload).subscribe({
        next: (res) => {
          this.loader.hide();
          if (res.success && res.code === 200) {
            localStorage.setItem('email', email);
            const queryParams = this.uuidClient > 0 ? { uuidc: this.uuidClient } : undefined;
            this.dialogNavigation.navigateAfterClose(this.dialogRef, '/codigocontrasena', queryParams);
          } else {
            this.correoIncorrecto = true;
          }
        },
        error: (err) => {
          this.loader.hide();
          if (err.status === 403) {
            this.correoIncorrecto = true;
          } else {
            console.error('Error inesperado:', err);
          }
        },
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
}
